import {commonActions} from '../../actions/commonActions';
import {postSetList} from '../../actions/reportActions';
import {connect} from 'react-redux';
import List from '../../components/report/Pos';
import {API_FETCH} from '../../services/FetchService';
import {commonConstants} from "../../constants";



const mapDispatchToProps = dispatch => ({
    onPageLoad: view => {
        dispatch(commonActions.pagePreLoaded(view))
    },
    getList: (value) => {
        dispatch(list(value));
    },
    /* ------------ -------------- ------------*/
    /* ------------ ON SUbmit Search Form ------------*/
    /* ------------ -------------- ------------*/
    onSubmit: (value)=>{
        dispatch(list(value));
    },

});

const list = (value) => {
    return (dispatch, getState) => {
        if(value) {
            if(value.created_from && value.created_from._d)
                value.created_from = value.created_from._d.toISOString()
            if(value.created_to && value.created_to._d)
                value.created_to = value.created_to._d.toISOString()
        }
        dispatch({type: commonConstants.FORM_REQUEST});
        API_FETCH.get('order/v2/reports?report_type=pos',{params: value}).then(list => {
            dispatch(postSetList(list.data.result));
            if(list.status === 200) {
                dispatch({type: commonConstants.FORM_SUCCESS});
            }else {
                dispatch({type: commonConstants.FORM_FAILURE});
            }
        }).catch(error => {
            console.log(error);
        });
    }

}

const mapStateToProps = state => {
    return {
        userValue    : state.app.currentUser,
        list         : state.report.posList,
        common       : state.common,
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(List);